

var defaultI18n = {
  prev: 'Prev',
  next: 'Next'
};

export { defaultI18n };